import React, { useState } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import classes from './index.module.scss';
import Preview_One from '../../assets/images/video-preview-one.jpg';
import Preview_Two from '../../assets/images/video-preview-two.jpg';
import Video from '../UI/Video';

const Videos = () => {
  const [visibility, setVisibility] = useState({
    video_one: true,
    video_two: true,
    video_three: true,
    video_four: true,
    video_five: true,
    video_six: true
  });

  const startPlayerHandler = (name) => {
    setVisibility({
      ...visibility,
      [name]: false
    });
  }

  return (
    <section className={classes.Videos}>
      <Container>
        <Row className="justify-content-center">
          <Col lg={6} className="mb-4">
            <Video 
              preview={Preview_One}
              startPlayerHandler={startPlayerHandler}
              visibility={visibility.video_one}
              title="About MatchForce.org"
              name="video_one"
              link="https://www.youtube.com/watch?v=KGU2GKuRLsM&ab_channel=NCMBCHQ"
            />
          </Col>
          <Col lg={6} className="mb-4">
            <Video 
              preview={Preview_One}
              startPlayerHandler={startPlayerHandler}
              visibility={visibility.video_two}
              title="MatchForce.org: Getting Started"
              name="video_two"
              link="https://www.youtube.com/watch?v=M0oyQg2DAo0&ab_channel=NCMBCHQ"
            />  
          </Col>
          <Col lg={6} className="mb-4">
            <Video 
              preview={Preview_One}
              startPlayerHandler={startPlayerHandler}
              visibility={visibility.video_three}
              title="MatchForce: Database"
              name="video_three"
              link="https://www.youtube.com/watch?v=A_JdhfWQoHE&ab_channel=NCMBCHQ"
            />  
          </Col>
          <Col lg={6} className="mb-4">
            <Video 
              preview={Preview_One}
              startPlayerHandler={startPlayerHandler}
              visibility={visibility.video_four}
              title="MatchForce: Future Opportunities"
              name="video_four"
              link="https://www.youtube.com/watch?v=OS3pJCG-8Jc&ab_channel=NCMBCHQ"
            />  
          </Col>
          <Col lg={6} className="mb-4">
            <Video 
              preview={Preview_One}
              startPlayerHandler={startPlayerHandler}
              visibility={visibility.video_five}
              title="MatchForce: Notifications"
              name="video_five"
              link="https://www.youtube.com/watch?v=-tiQpfYQIAo&ab_channel=NCMBCHQ"
            />  
          </Col>
          <Col lg={6} className="mb-4">
            <Video 
              preview={Preview_Two}
              startPlayerHandler={startPlayerHandler}
              visibility={visibility.video_six}
              title="About NCMBC"
              name="video_six"
              link="https://www.youtube.com/embed/dqKavPggb3M"
            />  
          </Col>
        </Row>
      </Container>
    </section>
  )
}

export default Videos;